<template>
  <div class="breadcrumbs__container">
    <div class="breadcrumbs__wrapper">
      <nuxt-link v-for="(page, ind) in prevPages" :key="ind" :to="localePath(page.link)" class="breadcrumbs__page">
        {{ page.label }}
      </nuxt-link>
      <span class="breadcrumbs__page breadcrumbs__page_current">
        {{ currentPage.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadcrumbsList',
  props: {
    pages: {
      type: Array,
      default: () => [
        {
          label: this.$t('common.home'),
          link: '/'
        }
      ]
    }
  },
  computed: {
    prevPages() {
      const pagesArray = this.pages !== undefined ? JSON.parse(JSON.stringify(this.pages)) : []
      if (pagesArray.length > 1) {
        pagesArray.splice(-1)
      }
      return pagesArray
    },
    currentPage() {
      return this.pages !== undefined
        ? this.pages[this.pages.length - 1]
        : {
            label: this.$t('common.home'),
            link: '/'
          }
    }
  }
}
</script>

<style scoped>
  @import url('~/assets/css/components/breadcrumbs.css');
</style>
